import Flickity from 'flickity';
import * as basicLightbox from 'basiclightbox';

const carousels = document.querySelectorAll('.photo-gallery');
let activeCarousels = [];
const carouselOptions = {
    cellAlign: 'left',
    initialIndex: 1,
    prevNextButtons: true,
    pageDots: false,
    contain: false,
    wrapAround: true,
    arrowShape: "M 72.37 97.59 C 70.96 97.59 69.55 97.03 68.42 95.9 L 26.69 53.6 C 24.43 51.34 24.43 47.96 26.69 45.7 L 68.42 3.69 C 70.68 1.43 74.06 1.43 76.32 3.69 C 78.58 5.95 78.58 9.33 76.32 11.59 L 38.53 49.65 L 76.32 88 C 78.58 90.26 78.58 93.92 76.32 95.9 C 75.47 97.03 73.78 97.59 72.37 97.59 Z"
};

// Initial Load
buildCarousel();

function buildCarousel(){
    activeCarousels = [];

    for(let i = 0, length3 = carousels.length; i < length3; i++){
        var flkty = new Flickity( carousels[i], carouselOptions);

        flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {

            const lightbox = cellElement.querySelectorAll('.lightbox');
            const i = 0;

            if(lightbox[i]){
                const image = lightbox[i].getAttribute('data-href');
                const width = lightbox[i].getAttribute('data-width');
                const height = lightbox[i].getAttribute('data-height');
                const caption = lightbox[i].getAttribute('data-caption');

                const instance = basicLightbox.create(`
                    <button class="lightbox-close">x</button>
                    <figure class="lightbox-modal m-0">
                        <img src="`+image+`" width="`+width+`" height="`+height+`" class="img-fluid">
                        <figcaption>`+caption+`</figcaption>
                    </figure>
                `,{
                    onShow: (instance) => {

                        document.addEventListener('keydown', function(event){
                            if(event.key === "Escape"){
                                instance.close();
                            }
                        });

                       window.setTimeout(function(){
                            document.querySelector('.lightbox-close').onclick = function(){
                                instance.close();
                            };
                       }, 400);
                    }
                });

                 instance.show();
            }
        });

        activeCarousels.push( flkty );
    }
}

function destroyCarousel(){
    for(let i = 0, length3 = activeCarousels.length; i < length3; i++){
        activeCarousels[i].destroy();
    }
}